import { CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_BLOCK_HASHES, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { STARKNET_ERC20_BALANCE_OF_SELECTOR, STARKNET_ETH_TOKEN, STARKNET_WALLET, } from "../../integration.js";
export const STARKNET_TEST_CONFIG = {
    balance: {
        address: STARKNET_WALLET,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS["starknet"],
    },
    tokenBalance: {
        address: STARKNET_WALLET,
        token: STARKNET_ETH_TOKEN,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS["starknet"],
    },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS["starknet"],
        fixture: "getBlockByNumberStarknet",
    },
    balanceQuery: {
        address: STARKNET_WALLET,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS["starknet"],
        fixture: "getBalanceStarknet",
    },
    tokenBalanceQuery: {
        address: STARKNET_WALLET,
        token: STARKNET_ETH_TOKEN,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS["starknet"],
        fixture: "getTokenBalanceStarknet",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES["starknet"],
        fixture: "getBlockByHashStarknet",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS["starknet"],
        fixture: "getBlockTransactionsStarknet",
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES["starknet"],
        fixture: "getReceiptStarknet",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES["starknet"],
        fixture: "getTransactionByHashStarknet",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES["starknet"],
        fixture: "traceTransactionStarknet",
    },
    // EVM-shaped envelope mapped onto starknet_call: `to` carries the contract
    // address, `data` carries the entry-point selector, and `value` is a single
    // optional calldata felt. Vector targets ERC-20 balanceOf(STARKNET_WALLET).
    simulateCallQuery: {
        to: STARKNET_ETH_TOKEN,
        data: STARKNET_ERC20_BALANCE_OF_SELECTOR,
        value: STARKNET_WALLET,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS["starknet"],
        fixture: "simulateCallStarknet",
    },
    // Forward the full-class lookup as a single contract address.
    codeQuery: {
        address: STARKNET_ETH_TOKEN,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS["starknet"],
        fixture: "getCodeStarknet",
    },
    // Starknet keys don't fit the EVM 32-byte topic regex, so topic0 is omitted
    // — the handler filters by address only and forwards to starknet_getEvents.
    logsQuery: {
        address: STARKNET_ETH_TOKEN,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS["starknet"]),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS["starknet"]),
        fixture: "getLogsStarknet",
    },
    // estimateGas vector targets the pinned wallet — Starknet fees aren't a flat
    // ~21000-style number; the matching integration test should treat the
    // response as opaque (no exact-equality assertion).
    estimateGasQuery: {
        to: STARKNET_WALLET,
        fixture: "estimateGasStarknet",
    },
};
